import clamp from 'lodash/clamp';
import {
	LINEAR_ZOOM_STEP,
	MAXIMUM_ZOOM_LEVEL,
	MINIMUM_ZOOM_LEVEL,
} from '../../constants/diagram.tsx';
import type { Zoom } from '../../types/index.tsx';
import type { ZoomDirection } from '../../constants/index.tsx';

const EXPONENTIAL_ZOOM_BASE = 2;
const LOGRAITHMIC_ZOOM_BASE = Math.log(2);

// convert exponential diagram zoom to a linear ak-range accessible value
export const getLinearZoom = (exponentialZoom: Zoom) =>
	Math.log(exponentialZoom) / LOGRAITHMIC_ZOOM_BASE;

// convert linear ak-range value to exponential diagram zoom value
export const getExponentialZoom = (linearZoom: Zoom) => EXPONENTIAL_ZOOM_BASE ** linearZoom;

export const getNextZoomStep = (zoom: number, direction: ZoomDirection) => {
	const step = direction === 'IN' ? LINEAR_ZOOM_STEP : -LINEAR_ZOOM_STEP;

	const nextLinearZoom = getLinearZoom(zoom) + step;
	const nextZoom = getExponentialZoom(nextLinearZoom);

	return clamp(nextZoom, MINIMUM_ZOOM_LEVEL, MAXIMUM_ZOOM_LEVEL);
};
